module.exports = __webpack_public_path__ + "resources/img/solution_commerce_rescue3.769012f6f710b3cfcdc9604f1a356b47.png";